// src/data/appealSigner.js
//
// MASTER LIST ITEM 4 (Bob 2026-10-14): "Appeals signed by whoever submits them." The claim's rule (Bob 2026-10-12, "the
// one who submits signs", claimPresentment.js / penaltyClaim.js) carried to the appeal ladder: an appeal to the next
// officer, and a notice of intent to a Board, are signed by the person submitting it - recorded on the act (signedBy),
// kept apart from who typed the record (recordedBy, ruling 70.3), and printed on the letter's signature block.
//
// Officer-side, as Bob holds it: the Local or General Chairperson submits the appeal. A member handling his own claim
// under Section 44 of the SMART constitution would be the one submitting and signing too; recording that from the
// member's own screen needs a rules opening that is NOT made here (an appeal act is written today only by an officer).
// PURE; proved by scripts\test-appeal-signer.mjs.

const s = (v) => (v === undefined || v === null ? '' : String(v).trim());
const TITLES = { local_chair: 'Local Chairperson', general_chair: 'General Chairperson', admin: 'Platform Administrator' };

// The signature block of the person submitting, from the signed-in account. null when the account is not one that
// submits appeals (no name, or a role that does not carry an appeal) - the caller refuses then, never guesses a signer.
export function appealSigner(user) {
  const u = user || {};
  const role = u.isAdmin && !TITLES[s(u.role)] ? 'admin' : s(u.role);
  const name = s(u.name) || s(u.displayName);
  if (!TITLES[role] || !name) return null;
  return { by: role, name: name.slice(0, 120), title: TITLES[role], committee: s(u.committee).slice(0, 40), uid: s(u.uid) };
}

// The act's stored signer, trimmed to what a record should hold.
export function signedByOf(signer) {
  if (!signer || typeof signer !== 'object' || !s(signer.name) || !s(signer.title)) return null;
  return { by: s(signer.by).slice(0, 30), name: s(signer.name).slice(0, 120), title: s(signer.title).slice(0, 80),
    committee: s(signer.committee).slice(0, 40), uid: s(signer.uid).slice(0, 128) };
}

// The block printed under the letter: the line is left blank for the signer's own hand.
export function signatureBlock(signer) {
  const sg = signedByOf(signer);
  if (!sg) return null;
  return ['Submitted and signed by:', '', '', '______________________________', sg.name,
    sg.title + (sg.committee ? ', ' + sg.committee : '')].join('\n');
}
